export const energyLineShaders = {
  vertexShader: `
    uniform float time;
    varying vec2 vUv;
    
    void main() {
      vUv = uv;
      vec3 pos = position;
      
      // Enhanced wave movement
      float wave = sin(time * 2.0 + position.x * 4.0) * 0.03;
      pos.y += wave;
      
      gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
    }
  `,

  fragmentShader: `
    uniform float time;
    uniform vec3 color1;
    uniform vec3 color2;
    varying vec2 vUv;
    
    void main() {
      // Enhanced energy flow effect
      float flow = fract(vUv.x * 3.0 - time * 1.5);
      
      // Improved electric current effect
      float electric = pow(flow, 1.8) * (1.0 - flow);
      electric *= 4.0; // Increased intensity
      
      // Enhanced noise for more organic look
      float noise = fract(sin(vUv.x * 100.0 + time * 5.0) * 43758.5453123);
      electric *= (0.85 + noise * 0.45);
      
      // Improved pulse effect
      float basePulse = 0.5; // Increased base opacity
      float pulseIntensity = 0.4; // Increased pulse range
      float pulse = basePulse + sin(time * 2.0) * pulseIntensity;
      
      // Enhanced color mixing
      vec3 finalColor = mix(color1, color2, flow) * 1.4; // Increased brightness
      
      // Improved glow effect
      float glow = pow(1.0 - abs(vUv.y - 0.5) * 2.0, 1.8);
      float finalOpacity = (electric * glow + glow * 0.4) * pulse;
      
      // Ensure higher minimum opacity
      finalOpacity = max(finalOpacity, 0.3);
      
      gl_FragColor = vec4(finalColor, finalOpacity);
    }
  `
}

export const fireShaders = {
  vertexShader: `
    varying vec2 vUv;
    varying vec3 vPosition;
    
    void main() {
      vUv = uv;
      vPosition = position;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform float time;
    uniform vec3 color;
    varying vec2 vUv;
    varying vec3 vPosition;
    
    // Noise functions
    float random(vec2 st) {
      return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
    }
    
    float noise(vec2 st) {
      vec2 i = floor(st);
      vec2 f = fract(st);
      
      float a = random(i);
      float b = random(i + vec2(1.0, 0.0));
      float c = random(i + vec2(0.0, 1.0));
      float d = random(i + vec2(1.0, 1.0));
      
      vec2 u = f * f * (3.0 - 2.0 * f);
      return mix(a, b, u.x) + (c - a)* u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
    }
    
    void main() {
      // Create fire effect
      float n = noise(vec2(vUv.x * 4.0 + time * 0.5, vUv.y * 4.0 - time * 2.0));
      float n2 = noise(vec2(vUv.x * 8.0 - time * 0.2, vUv.y * 8.0 - time * 3.0));
      
      // Gradient for fire shape
      float gradient = 1.0 - vUv.y;
      
      // Combine noises
      float fireNoise = n * n2 * gradient;
      
      // Create color variations
      vec3 fireColor = mix(color, vec3(1.0, 0.5, 0.0), fireNoise);
      
      // Add glow
      float glow = pow(gradient, 3.0);
      
      // Final color with transparency
      float alpha = fireNoise * gradient;
      alpha = smoothstep(0.1, 0.6, alpha);
      
      gl_FragColor = vec4(fireColor, alpha * 0.8);
    }
  `
} 